import React, { useId } from "react";

const BlockIcon = ({ className }) => {
  const gradientId = useId();

  return (
    <svg
      className={className}
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="18"
        height="12"
        rx="6"
        fill={`url(#${gradientId})`}
        fillOpacity="0.6"
      />
      <path
        d="M11.1452 4.29413V3.69231C11.1452 2.48354 10.1828 1.5 9 1.5C7.81723 1.5 6.85484 2.48354 6.85484 3.69231V4.29413C5.97961 4.41275 5.5 5.00585 5.5 6V8.76923C5.5 9.88523 6.10155 10.5 7.19355 10.5H10.8065C11.8985 10.5 12.5 9.88523 12.5 8.76923V6C12.5 5.00631 12.0204 4.41321 11.1452 4.29413ZM9 2.19231C9.80929 2.19231 10.4677 2.86523 10.4677 3.69231V4.26923H7.53226V3.69231C7.53226 2.86523 8.19071 2.19231 9 2.19231ZM11.8226 8.76923C11.8226 9.49708 11.5186 9.80769 10.8065 9.80769H7.19355C6.48135 9.80769 6.17742 9.49708 6.17742 8.76923V6C6.17742 5.27215 6.48135 4.96154 7.19355 4.96154H10.8065C11.5186 4.96154 11.8226 5.27215 11.8226 6V8.76923ZM9.57356 6.92308C9.57356 7.11323 9.47781 7.27387 9.33871 7.37864V8.30769C9.33871 8.49877 9.18697 8.65385 9 8.65385C8.81303 8.65385 8.66129 8.49877 8.66129 8.30769V7.36704C8.53123 7.26134 8.44221 7.10538 8.44221 6.92308C8.44221 6.60462 8.69291 6.34615 9.00452 6.34615H9.00904C9.32065 6.34615 9.57356 6.60462 9.57356 6.92308Z"
        fill="#C2C2C2"
      />
      <defs>
        <radialGradient
          id={gradientId}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(14.5 6.33333 -9.5 9.66667 1 4.33333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C22" />
          <stop offset="0.299376" stopColor="#FF4000" />
          <stop offset="0.313591" stopColor="#FF4000" />
          <stop offset="0.494272" stopColor="#FF6C22" />
          <stop offset="0.696022" stopColor="#FFCBB1" />
          <stop offset="1" stopColor="#FF4000" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export default BlockIcon;
